// CustomSourceSelect.js
import React from 'react';

const sourceOptions = [
	'Facebook',
	'Google Places',
	'Google Ads',
	'Google Local Services',
	'Organic',
	'SMS',
	'Email',
	'Traditional Media',
	'Unknown',
];

const CustomSourceSelect = ({ value, onChange }) => {
	return (
		<select
			value={value || ''}
			onChange={(e) => onChange(e.target.value)}
			style={{
				width: '100%',
				maxWidth: '130px',
				padding: '4px 6px',
				borderRadius: '4px',
				fontSize: '1.2rem',
				overflow: 'hidden',
				whiteSpace: 'nowrap',
				textOverflow: 'ellipsis',
			}}
		>
			<option value='' style={{ fontSize: '1.2rem' }}>
				Select Source
			</option>
			{sourceOptions.map((option) => (
				<option key={option} value={option}>
					{option}
				</option>
			))}
		</select>
	);
};

export default CustomSourceSelect;
